import {Stage} from "./base/Display2D.js";
import {Site} from "./site/Site.js";
import {Navigation} from "./site/Navigation.js";

 import jQuery from 'jquery';
 import Boostrap from 'bootstrap';

/**
 * Setup jQuery globally for cookie layer
 */
window.$ = jQuery
window.jQuery = jQuery

//
// setup
//
!function setUpContent () {
	window.Navigation = Navigation;

	function startUp () {
		var controllerElement = document.querySelector ("header");
		if (controllerElement) {
			var controller = Stage.fromElement.call (
				Navigation, controllerElement

			);

		}

		var controllerElement = document.querySelector ("main") || document.body;
		if (controllerElement) {
			var controller = Stage.fromElement.call (
				Site, controllerElement

			);

		}

	}

	window.addEventListener ("DOMContentLoaded", startUp);

} ();
